var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPredibase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#C81D0B"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.154,
    y: 8.924,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.924,
    y: 8.924,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.385,
    y: 8.924,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.616,
    y: 8.924,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 8.924,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8.924,
    y: 10.154,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.616,
    y: 10.154,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 10.154,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 11.385,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 12.616,
    y: 11.385,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 11.385,
    y: 11.385,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 11.385,
    y: 10.154,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 10.154,
    y: 10.154,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 10.154,
    y: 11.385,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 8.924,
    y: 11.385,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 8.924,
    y: 12.616,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 8.924,
    y: 13.846,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 10.154,
    y: 12.616,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 10.154,
    y: 13.846,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 11.385,
    y: 12.616,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 11.385,
    y: 13.846,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 12.616,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 13.846,
    y: 13.846,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 12.616,
    y: 12.616,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 12.616,
    y: 13.846,
    width: 1.231,
    height: 1.231,
    rx: 0.615
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.539 18.77a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0A.615.615 0 1112 20a.615.615 0 010-1.23zm1.232 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zM9.54 17.537a.616.616 0 11-.002 1.232.616.616 0 01.002-1.232zm1.23 0a.616.616 0 11-.001 1.232.616.616 0 01.001-1.232zm1.23 0a.616.616 0 110 1.232.616.616 0 010-1.232zm1.232 0a.616.616 0 11-.002 1.232.616.616 0 01.002-1.232zm1.23 0a.616.616 0 110 1.232.616.616 0 010-1.232zm1.231 0a.616.616 0 11-.001 1.232.616.616 0 01.001-1.232zm-6.153-1.23a.616.616 0 110 1.23.616.616 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.616.616 0 110 1.23.616.616 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.231 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zM9.54 15.077a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.615.615 0 110 1.231.615.615 0 010-1.231zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.231 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.616.616 0 110 1.231.616.616 0 010-1.231zm-2.462-1.23a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm-3.692-1.23a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm-3.692-1.232a.616.616 0 110 1.23.616.616 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.616.616 0 11-.001 1.231.616.616 0 01.001-1.231zm1.23 0a.616.616 0 110 1.231.616.616 0 010-1.231zm-3.692-1.23a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.616.616 0 110 1.23.616.616 0 010-1.23zm-3.692-1.231a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.232 0a.615.615 0 110 1.23.615.615 0 010-1.23zm1.23 0a.615.615 0 110 1.23.615.615 0 010-1.23z",
    fill: "#FF622B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.461 5.232A.616.616 0 1114.462 4a.616.616 0 010 1.232zm-1.23 0a.616.616 0 110-1.232.616.616 0 010 1.232zm-1.23 0A.615.615 0 1112 4a.615.615 0 010 1.23zm-1.231 0a.616.616 0 110-1.233.616.616 0 010 1.233zm-1.231 0a.615.615 0 110-1.231.615.615 0 010 1.23zm4.922 1.23a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.231 0a.616.616 0 110-1.232.616.616 0 010 1.232zm-1.231 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm6.152 1.23a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.231 0a.616.616 0 110-1.231.616.616 0 010 1.232zm-1.231 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.231 0a.615.615 0 110-1.23.615.615 0 010 1.23zm7.383 1.231a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.231 0a.616.616 0 110-1.232.616.616 0 010 1.232zm-1.231 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.231 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.232 0a.616.616 0 110-1.231.616.616 0 010 1.231zm2.462 1.232a.616.616 0 110-1.232.616.616 0 010 1.232zm-1.23 0a.616.616 0 110-1.232.616.616 0 010 1.232zm-2.461 0a.616.616 0 11.615-.62.615.615 0 110 .01.616.616 0 01-.615.61zm3.691 1.23a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-2.461 0a.616.616 0 11.615-.62.615.615 0 110 .01.616.616 0 01-.615.61zm3.691 1.23a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-2.461 0a.616.616 0 11.615-.619.615.615 0 110 .01.615.615 0 01-.615.61zm3.691 1.23a.615.615 0 110-1.23.615.615 0 010 1.23zm-1.23 0a.615.615 0 110-1.23.615.615 0 010 1.23zm-2.461 0a.616.616 0 11.615-.618.615.615 0 110 .009.615.615 0 01-.615.61zm3.691 1.232a.616.616 0 11.001-1.231.616.616 0 010 1.231zm-1.23 0a.616.616 0 110-1.23.616.616 0 010 1.23zm-2.461 0a.616.616 0 11.615-.619.615.615 0 110 .009.616.616 0 01-.615.61z",
    fill: "#0E0C0C"
  })));
}
export default __webpack_public_path__ + "static/predibase.de8eaa47.svg";
export { SvgPredibase as ReactComponent };